module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/emirates/emirates.component.scss
// module id = ./client/app/emirates/emirates.component.scss
// module chunks = main